import { render } from "./Me.vue?vue&type=template&id=3036f274&scoped=true"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"

import "./Me.vue?vue&type=style&index=0&id=3036f274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3036f274"]])

export default __exports__